import { render, staticRenderFns } from "./operate-dialog.vue?vue&type=template&id=5f2645c5&scoped=true"
import script from "./operate-dialog.vue?vue&type=script&lang=js"
export * from "./operate-dialog.vue?vue&type=script&lang=js"
import style0 from "./operate-dialog.vue?vue&type=style&index=0&id=5f2645c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2645c5",
  null
  
)

export default component.exports